import { _pagination,monthNames } from '../config/setting';
import moment from 'moment';

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date) {
    date = new Date(date); //Date pass
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return (day <= 9 ? '0' + day : day) + "-" +  (month <= 9 ? '0' + month : month) + "-" + year
}

//convert monthFormate
export function convertMonthFormate(date) {
    date = new Date(date); //Date pass
    let month = date.getMonth();
    let year = date.getFullYear();

    return (monthNames[month] + " " + year)
}

//convert date with month name 
export function convertMonthFormatWithName(date){
    date = new Date(date); //Date pass\
    let month = date.getMonth();

    return (monthNames[month]);
}

//convert date with month name 
export function convertOnlyDate(date){
    date = new Date(date); //Date pass\
    let datefr = date.getDate();

    return (datefr <= 9 ? '0' + datefr : datefr);
}

//pagination
export const setPagination = function (page = _pagination.page, perpage = _pagination.perpage, totalpages = 0, total = 0) {
    let pagination = _pagination;
    const from = ((page * perpage) - perpage) + 1;
    const to = totalpages === page ? total : perpage * page;
    const hasPrevious = page > 1;
    const hasNext = totalpages > page;
    const showing = total > 0 ? `Showing ${from} to ${to} of ${total} entries` : null;
    pagination = { ...pagination, hasNext: hasNext, hasPrevious: hasPrevious, page: page, perpage: perpage, showing: showing }
    return pagination;
}



export const ConvertGMTIST = function (date) {
    return date ? moment.utc(date).local().format("DD MMM YYYY") : null;
  };
  
  export const ConvertTimeGMTIST = function (date) {
    return date ? moment.utc(date).local().format("DD MMM YYYY, hh:mm A") : null;
  };